import React from 'react'
import Portfolio from '../../componets/Portfolio'

const Section1 = () => {
  return (
    <div className="w-full md:h-[30vh] xl:h-[60vh] Section1">
              <Portfolio
                bgImage={"/assets/case-studies-banner.png"}
                objectPosition={"center-center"}
                customer={false}
                altText="Case Studies Background Image"
                headertext="OUR IMPACT: REAL STORIES OF CLIENT SUCCESS"
                bannerHeading="CASE STUDIES "
                showPortfolioBtn = {false}
              />
            </div>
  )
}

export default Section1
